import { Filters } from '../reduxTypes';

// default market filters for GSK
export const defaultMarketFilters = [
  {
    name: 'Region',
    values: [
      {
        id: '398',
        name: 'Americas',
        type: null
      }
    ]
  },
  {
    name: 'Retailer',
    values: [
      {
        id: '1',
        name: 'Amazon',
        type: null
      }
    ]
  },
  {
    name: 'Market',
    values: [
      {
        id: '1',
        region_id: null,
        name: 'United States'
      }
    ]
  },
  null,
  null,
  null,
  null,
  {
    name: 'Share',
    values: [
      {
        id: '1P',
        name: '1P'
      }
    ]
  },
  {
    name: 'Campaign Type',
    values: [
      {
        id: '610028',
        name: 'Sponsored Brands'
      },
      {
        id: '610030',
        name: 'Sponsored Products'
      },
      {
        id: '611803',
        name: 'Sponsored Brand Video'
      }
    ]
  }
];

const cleanState = {
  market: [],
  dates: {
    range: 'Last 3 Months',
    custom: null,
    customNotes: null
  }
};

const initialState: Filters = {
  ...cleanState
};

interface ReduxProps {
  type: string;
  value: any;
}

export default (state = initialState, { type, value }: ReduxProps): any => {
  switch (type) {
    case 'SET_MARKET_FILTERS':
      return {
        ...state,
        market: value
      };
    case 'SET_DATES_FILTERS':
      return {
        ...state,
        dates: value
      };
    default:
      return state;
  }
};
